import { render, staticRenderFns } from "./BreastCancer.vue?vue&type=template&id=17eb8e55&"
import script from "./BreastCancer.vue?vue&type=script&lang=js&"
export * from "./BreastCancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports